import { c as _c } from "react/compiler-runtime";
import { RedTriangleCaution } from '@components/RedTriangleCaution';
import { Button, Flex, Text } from '@endurancewarranty/ui';
import type { FC } from 'react';
type Props = {
  onClose: () => void;
};
export const VinUpdateChangesVehicleModal: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Flex justify="center"><RedTriangleCaution className="h-14 w-14" /></Flex>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-4"><Text.Header fontWeight="bold">VIN Update Not Allowed</Text.Header><Text.Body wordBreak="normal">VIN updates cannot change year, make, model, or series. This contract must be canceled and a new one sold for the correct vehicle.</Text.Body></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose) {
    t3 = <Flex direction="col">{t1}{t2}<Flex justify="end" className="mt-4 gap-2"><Button name="vin-update-changes-vehicle-modal-ok" variant="primary" onClick={onClose}>OK</Button></Flex></Flex>;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};